import { useEffect, useState } from 'react'
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
} from '@mui/material'
import { DIALOGS } from '~/components/Charts/chrome/chartChrome'

interface Props {
  open: boolean
  initialTitle: string
  initialDescription: string
  onClose: () => void
  onSubmit: (next: { title: string; description: string }) => void | Promise<void>
  isSubmitting?: boolean
  error?: string | null
}

export function PinEditDialog({
  open,
  initialTitle,
  initialDescription,
  onClose,
  onSubmit,
  isSubmitting = false,
  error = null,
}: Props) {
  const [title, setTitle] = useState(initialTitle)
  const [description, setDescription] = useState(initialDescription)

  useEffect(() => {
    if (open) {
      setTitle(initialTitle)
      setDescription(initialDescription)
    }
  }, [open, initialTitle, initialDescription])

  const trimmedTitle = title.trim()
  const canSubmit = trimmedTitle.length > 0 && !isSubmitting

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{DIALOGS.editPin}</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ pt: 1, minWidth: 360 }}>
          <TextField
            label={DIALOGS.title}
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
          <TextField
            label={DIALOGS.description}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            multiline
            rows={3}
          />
          {error ? <Alert severity="error">{error}</Alert> : null}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{DIALOGS.cancel}</Button>
        <Button
          onClick={() => onSubmit({ title: trimmedTitle, description })}
          disabled={!canSubmit}
          variant="contained"
        >
          {DIALOGS.save}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
